import SectionAwards from "../SectionAwards"
import SectionFeatures from "../SectionFeatures"
import SectionFitIn from "../SectionFitIn"
import SectionGoogleReviews from "../SectionGoogleReviews"
import SectionImageGrid from "../SectionImageGrid"
import SectionProductCards from "../SectionProductCards"
import SectionSteps from "../SectionSteps"
import SectionTeam from "../SectionTeam"

const SectionCards = ({ section }: any) => {
  const { tags } = section

  if (tags.includes("section-awards")) {
    return <SectionAwards section={section} />
  } else if (
    tags.includes("section-steps") ||
    tags.includes("realtors-cards")
  ) {
    return <SectionSteps section={section} />
  } else if (tags.includes("section-fit-in")) {
    return <SectionFitIn section={section} />
  } else if (tags.includes("section-google-review")) {
    return <SectionGoogleReviews section={section} />
  } else if (tags.includes("section-team")) {
    return <SectionTeam section={section} />
  } else if (tags.includes("section-features")) {
    return <SectionFeatures section={section} />
  } else if (tags.includes("section-product-cards")) {
    return <SectionProductCards section={section} />
  } else if (tags.includes("section-image-grid")) {
    return <SectionImageGrid section={section} />
  }
  return null
}

export default SectionCards
